import React from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import * as styled from './primitives';
import { THROTTLE_WAIT } from '../../constants.js';

export class StickySearchBarWrapper extends React.PureComponent {
    state = {
        stickySearchBar: false,
    };

    static propTypes = {
        // the vertical distance the user can scroll before the StickySearchBarWrapper
        // stickies itself and its props.children to the top of the window
        verticalScrollLimit: PropTypes.number,
    };

    static defaultProps = {
        verticalScrollLimit: null,
    };

    componentDidMount() {
        window.addEventListener('scroll', this.stickySearchBar);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.stickySearchBar);
    }

    // sticky the search bar when user is about to scroll vertically past the search bar
    stickySearchBar = throttle(() => {
        let verticalScroll = window.pageYOffset;

        // support older IE versions; see https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
        if (typeof verticalScroll === 'undefined') {
            const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
            verticalScroll = isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
        }

        this.setState({ stickySearchBar: verticalScroll > this.props.verticalScrollLimit });
    }, THROTTLE_WAIT);

    render() {
        const {
            children,
        } = this.props;

        return (
            <styled.StickySearchBarContainer
                data-test="universal-search-header-bottom"
                isSticky={this.state.stickySearchBar}
            >
                {children}
            </styled.StickySearchBarContainer>
        );
    }
}
